import { Filters } from '../../_flux/constants/filter/filters';

export const CHECK_ORDER = [
    Filters.WIDTH,
    Filters.HEIGHT,
    Filters.DIAMETER,
    Filters.LOAD_INDEX,
    Filters.SPEED_INDEX,
    Filters.MANUFACTURER,
];

export const CHECK_ADDITIONAL = [
    Filters.USAGE,
    Filters.VEHICLE_TYPE,
    Filters.RUN_FLAT,
    Filters.FREE_FITTING,
    Filters.BUY_4_PAY_3,
    Filters.CLEARANCE,
    Filters.DISCOUNT_INSTANT_CASH_50,
    Filters.DISCOUNT_INSTANT_CASH_80,
    Filters.DISCOUNT_INSTANT_CASH_100,
    Filters.DISCOUNT_INSTANT_CASH_120,
    Filters.DISCOUNT_INSTANT_CASH_150,
    Filters.DISCOUNT_INSTANT_CASH_160,
    Filters.DISCOUNT_INSTANT_CASH_200,
    Filters.DISCOUNT_INSTANT_CASH_250,
    Filters.DISCOUNT_INSTANT_CASH_300,
    Filters.DISCOUNT_5_OFF,
    Filters.DISCOUNT_10_OFF,
    Filters.DISCOUNT_15_OFF,
    Filters.DISCOUNT_20_OFF,
    Filters.DISCOUNT_25_OFF,
    Filters.PROMO_GIFT_CARD_50,
    Filters.PROMO_GIFT_CARD_80,
    Filters.PROMO_GIFT_CARD_100,
    Filters.PROMO_GIFT_CARD_130,
    Filters.PROMO_GIFT_CARD_150,
    Filters.PROMO_GIFT_CARD_200,
    Filters.PROMO_GIFT_CARD_250,
    Filters.TECHNOLOGY,
    Filters.LABEL_NOISE,
    Filters.LABEL_WET_GRIP,
    Filters.LABEL_FUEL_EFFICIENCY,

    Filters.UTQG_TREADWEAR_GROUP,
    Filters.UTQG_TRACTION,
    Filters.UTQG_TEMPERATURE,
    Filters.SEASON,
    Filters.EV,
    Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP,
    Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP,
    Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP,
    Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP,
    Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP,
    Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP,
    Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP,

    Filters.QUALITY_SEGMENT_PREMIUM,
    Filters.QUALITY_SEGMENT_VALUE,
    Filters.QUALITY_SEGMENT_BUDGET,
];
